<div class="flex items-start gap-md">
  <sb-switch [formControl]="serviceDeskAccessCtrl" [ariaLabel]="'Support Access' | translate" />
  <sb-support-text-block
    [title]="'Support Access' | translate"
    [body]="
      'Grant Shiftbase support access to your account for troubleshooting. You can revoke access anytime.' | translate
    "
  />
</div>
